import { createAsyncStateHook } from './utils'
import { getNewsletter, getNewsletters } from 'src/services/newsletterServices'

export const useNewsletters = createAsyncStateHook(
  'newsletters',
  getNewsletters
)
export const useNewsletter = createAsyncStateHook('newsletter', getNewsletter)
